<template>
  <BaseModal ref="modal">
    <UiModalDialog
      :no-header="!_title"
      :no-closer="!_modalProps?.closeable"
      :dialog-width="_dialogWidth"
      dialog-height="40vh"
      dialog-min-height="36rem"
    >
      <template #header>
        <BaseIcon v-if="_icon" :name="_icon" />
        {{ ls(_title) }}
      </template>
      <div class="jps-modal-content">
        <p v-if="_message">{{ ls(_message) }}</p>
        <form @submit.prevent="ok()">
          <ValidationForm :rule="_rule" :target="_target" :only="_only" :except="_except" @valid="(v) => valid = v" />
        </form>
      </div>
      <template #buttons>
        <button @click="modal.reject()">{{ ls(ngLabel) }}</button>
        <button @click="ok()" :disabled="!valid">{{ ls(okLabel) }}</button>
      </template>
    </UiModalDialog>
  </BaseModal>
</template>

<script lang="ts" setup>
import type { BaseModal } from '#components'
import type { SVG_NAMES } from '~/components/icons'
import type { ModalProps } from '~/components/base/BaseModal.vue'

const { ls } = useI18n()

interface Props {
  icon?: SVG_NAMES
  title?: LangString
  message?: LangString
  okLabel?: LangString
  ngLabel?: LangString
  rule?: ValidationRule
  target?: any
  only?: string
  except?: string
  dialogWidth?: string
}
const props = withDefaults(defineProps<Props>(), {
  okLabel: { ja: 'OK' },
  ngLabel: { ja: 'キャンセル', en: 'Cancel' },
})

const modal = ref<InstanceType<typeof BaseModal>>()
const _icon: Ref<SVG_NAMES> = ref()
const _title: Ref<LangString> = ref()
const _message: Ref<LangString> = ref()
const _okLabel: Ref<LangString> = ref()
const _ngLabel: Ref<LangString> = ref()
const _rule: Ref<ValidationRule> = ref()
const _target: Ref<any> = ref()
const _only: Ref<string> = ref()
const _except: Ref<string> = ref()
const _dialogWidth: Ref<string> = ref()
const _modalProps: Ref<ModalProps> = ref()
const openAwait = async (options?: Props, modalProps?: ModalProps) => {
  setOptionsValue(_icon, 'icon', props, options)
  setOptionsValue(_title, 'title', props, options)
  setOptionsValue(_message, 'message', props, options)
  setOptionsValue(_okLabel, 'okLabel', props, options)
  setOptionsValue(_ngLabel, 'ngLabel', props, options)
  setOptionsValue(_rule, 'rule', props, options)
  setOptionsValue(_target, 'target', props, options)
  setOptionsValue(_only, 'only', props, options)
  setOptionsValue(_except, 'except', props, options)
  setOptionsValue(_dialogWidth, 'dialogWidth', props, options)
  valid.value = false
  _modalProps.value = modalProps
  return await modal.value.openAwait<any>(_modalProps.value)
}
defineExpose({ openAwait })

const valid: Ref<boolean> = ref(false)

const ok = () => {
  if (valid.value) {
    modal.value.resolve(_target.value)
  }
}
</script>
